import React, { useState, useEffect } from 'react';
import styles from './LineOutGraphs.module.css';
import TopNRecordsLineGraph from '../TopNRecordsLineGraph/TopNRecordsLineGraph';
import {
  getDayWiseLineOutReasonsGraphData,
  getDayWiseLineOutAgenciesGraphData,
  getWeekWiseLineOutReasonsGraphData,
  getWeekWiseLineOutAgenciesGraphData,
} from '../../utils/graphDataUtils';
import { API_RESOURCE_URLS, TIME_DURATION } from '../../constants';
import { API } from '../../apis/api';
import axios from 'axios';

const LineOutGraphs = ({
  plant,
  line,
  durationText,
  startDateTime,
  endDateTime,
  ...props
}) => {
  const [lineOutReasonsGraphData, setLineOutReasonsGraphData] = useState([]);
  const [lineOutAgenciesGraphData, setLineOutAgenciesGraphData] = useState([]);
  const [reasonMaxCount, setReasonMaxCount] = useState(0);
  const [agencyMaxCount, setAgencyMaxCount] = useState(0);
  const [rawData, setRawData] = useState([]);
  const [isGraphLoading, setIsGraphLoading] = useState(true);

  const fetchLineOutStatisticsDataForGivenDateRange = async (
    selectedPlant,
    selectedLine,
    selectedStartDateTime,
    selectedEndDateTime,
    APICancelTokenSource,
  ) => {
    const response = await API.get(API_RESOURCE_URLS.LINE_OUT_STATISTICS, {
      params: {
        plant: selectedPlant,
        line: selectedLine,
        from: selectedStartDateTime,
        to: selectedEndDateTime,
      },
      cancelToken: APICancelTokenSource.token,
    });
    return response.data;
  };

  useEffect(() => {
    setIsGraphLoading(true);
    const cancelTokenSource = axios.CancelToken.source();
    fetchLineOutStatisticsDataForGivenDateRange(
      plant,
      line,
      startDateTime,
      endDateTime,
      cancelTokenSource,
    )
      .then(res => setRawData(res))
      .then(setIsGraphLoading(false));
  }, [plant, line, startDateTime, endDateTime]);

  useEffect(() => {
    const [reasonMaxRecordCount, reasonGraphDataArray] =
      durationText === TIME_DURATION.LAST_SEVEN_DAYS
        ? getDayWiseLineOutReasonsGraphData(rawData, startDateTime, endDateTime)
        : getWeekWiseLineOutReasonsGraphData(
            rawData,
            startDateTime,
            endDateTime,
          );
    setLineOutReasonsGraphData(reasonGraphDataArray);
    setReasonMaxCount(reasonMaxRecordCount);

    const [agencyMaxRecordCount, agencyGraphDataArray] =
      durationText === TIME_DURATION.LAST_SEVEN_DAYS
        ? getDayWiseLineOutAgenciesGraphData(
            rawData,
            startDateTime,
            endDateTime,
          )
        : getWeekWiseLineOutAgenciesGraphData(
            rawData,
            startDateTime,
            endDateTime,
          );
    setLineOutAgenciesGraphData(agencyGraphDataArray);
    setAgencyMaxCount(agencyMaxRecordCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawData]);

  return (
    <>
      <div>
        <div className={styles.innerGraphContainer}>
          <div className={styles.topNRecordsLineGraph}>
            <div className={styles.heading}>Reason (Top contributors)</div>
            <TopNRecordsLineGraph
              data={lineOutReasonsGraphData}
              maxRecordCount={reasonMaxCount}
              isLoading={isGraphLoading}
              durationText={durationText}
              label="count"
            />
          </div>

          <div className={styles.topNRecordsLineGraph}>
            <div className={styles.heading}>Agency (Top contributors)</div>
            <TopNRecordsLineGraph
              data={lineOutAgenciesGraphData}
              maxRecordCount={agencyMaxCount}
              isLoading={isGraphLoading}
              durationText={durationText}
              label="count"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LineOutGraphs;
